import { tv, type VariantProps } from "tailwind-variants";

export const inputRadioVariant = tv({
  slots: {
    base: ["flex", "items-center", "gap-2"],
    label: [],
    inputWrapper: ["relative", "flex", "items-center", "justify-center", "w-6", "h-6"],
    input: ["opacity-0", "peer", "absolute", "inset-0", "z-3"],
    radio: [
      "relative",
      "z-2",
      "flex",
      "items-center",
      "justify-center",
      "w-6",
      "h-6",
      "rounded-full",
      "border-2",
      "border-neutral-dark-alpha-4",
      "bg-transparent",
      "before:content-['']",
      "before:flex",
      "before:w-2.5",
      "before:h-2.5",
      "before:rounded-full",
      "before:bg-transparent",
      "peer-checked:border-background-neutral-inverse",
      "peer-checked:before:bg-background-neutral-inverse",
    ],
  },
  variants: {},
  defaultVariants: {},
});

export type InputRadioVariantProps = VariantProps<typeof inputRadioVariant>;
export type InputRadioReturnVariantProps = ReturnType<typeof inputRadioVariant>;
